import React from "react";
import SubHeader from "../components/SubHeader";
import moment from "moment";
import Wrapper from "../components/Layout/Wrapper";
import styled from "styled-components";
import useAuth from "../hooks/useAuth";
import "react-markdown-editor-lite/lib/index.css";
import { Badge, Calendar } from "antd";
import { NavLink } from "react-router-dom";
import useClasses from "../hooks/useClasses";
import { Session } from "../types";

const ContentPageWrapper = styled.div`
  padding-bottom: 32px;
  .sub-header {
    margin-bottom: 16px;
  }
  main {
    width: 100%;
    margin-right: 5%;
  }
`;

const CalendarPage = () => {
  const { accountDetails, isAdmin } = useAuth();
  const { data: classData } = useClasses();

  if (!classData?.length) {
    return <div>Loading</div>;
  }

  const classes = accountDetails?.isSuperuser
    ? classData
    : (classData || []).filter(
        (klass) =>
          (klass.students || []).some(
            (student) => student.id === accountDetails?.id
          ) ||
          (klass.teachers || []).some(
            (teacher) => teacher.teacherId === accountDetails?.id
          )
      );

  const sessionsForClasses = classes.reduce(
    (ids, klass) => [
      ...ids,
      ...(klass.sessions || []).map((x) => ({ ...x, classId: klass.id })),
    ],
    [] as (Session & { classId: string })[]
  );

  return (
    <ContentPageWrapper>
      <SubHeader
        title={"Your calendar"}
        subtitle={`Keep track of when your next session is.`}
      />
      <Wrapper style={{ justifyContent: "space-between", width: 1280 }}>
        <main>
          <Calendar
            dateCellRender={(value) => {
              const sessionsOnDay = sessionsForClasses.filter((x) =>
                moment(x?.startTime).isSame(value, "d")
              );
              return (
                <div
                  className="wrapper"
                  style={{
                    width: "100%",
                    height: "100%",
                    opacity: value.clone().add(1, "d").isBefore() ? "0.6" : "1",
                  }}
                >
                  <div className="events">
                    {sessionsOnDay.map((item) => (
                      <NavLink
                        to={
                          isAdmin
                            ? `class/${item.classId}?date=${+value}`
                            : `class/${item.classId}/session/${item?.id}`
                        }
                      >
                        <Badge
                          status={item?.isVisible ? "success" : "error"}
                          text={item?.name}
                        />
                      </NavLink>
                    ))}
                  </div>
                </div>
              );
            }}
          />
        </main>
      </Wrapper>
    </ContentPageWrapper>
  );
};

export default CalendarPage;
